module.exports = __webpack_public_path__ + "img/hair_and_makeup.0dbf4ef9.jpg";